import redirect from 'nextjs-redirect';
import UnknownProgressLoader from 'admin/src/components/UnknownProgressLoader';
// @ts-ignore
const Redirect = redirect( process.env.GOOGLE_AUTHORIZATION_URL );

export default function RedirectContainer() {
	return <Redirect>
		<UnknownProgressLoader/>
	</Redirect>;
}

export const getServerSideProps = async (context: any) => {
  const { req } = context;
  const isAdminPage = req.headers.host.split(".")[0] === "om-admin";

  if (!isAdminPage) {
    return {
      redirect: {
        destination: '/',
        permanent: false,
      },
    };
  }

  return {
    props: {
      isAdminPage: isAdminPage,
    },
  };
};